/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown> }} Delete_Transcript_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete the transcript file for {project}?" |
*
* @param {Delete_Transcript_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_transcript_text = /** @type {((inputs: Delete_Transcript_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Transcript_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer le fichier de transcription pour ${i?.project} ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie die Protokolldatei für ${i?.project} wirklich löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare il file di trascrizione per ${i?.project}?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить файл с расшифровкой для ${i?.project}?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar el archivo de transcripción de ${i?.project}?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除 ${i?.project} 的成绩单文件吗？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.project} のトランスクリプトファイルを削除してもよろしいですか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.project} के लिए ट्रांसक्रिप्ट फ़ाइल को हटाना चाहते हैं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir o arquivo de histórico escolar de ${i?.project}?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the transcript file for ${i?.project}?`)
});